// Import Core Components here
import React, { Component } from "react";
import PropTypes from "prop-types";

// Import App depedency here
import { Input } from "arv-reactcomponents";

class UserNameInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserInputValid: false,
      userInputErrorMsg: "",
      userName: "",
      userNameErrorClass: "",
      isValid: "is-invalid is-untouched",
    };

    this.onBlur = this.onBlur.bind(this);
    this.validateUserName = this.validateUserName.bind(this);
  }

  onBlur() {
    let userNameErrorClass = "nwc-hidden";
    let isValid = "";
    if (!this.state.isUserInputValid) {
      userNameErrorClass = "";
      isValid = "is-invalid";
    }
    this.setState({ userNameErrorClass, isValid });
  }

  validateUserName(e) {
    this.setState({ userNameErrorClass: "nwc-hidden" });
    const validateUserField = this.validateUserFieldRef.getValidatedOutput(
      e.target.value,
    );
    this.setState({
      userName: validateUserField.value,
      isUserInputValid: validateUserField.isValid,
      userInputErrorMsg: validateUserField.errorMsg,
      isValid: "",
    });
  }

  render() {
    const {
      userInputErrorMsg,
      userName,
      userNameErrorClass,
      isValid,
    } = this.state;
    const { className, placeholder, name } = this.props;
    return (
      <div>
        <Input
          className={`${className} ${isValid}`}
          name={name}
          onBlur={this.onBlur}
          onChange={this.validateUserName}
          onFocus={this.onFocus}
          placeholder={placeholder}
          type="text"
          value={userName}
          ref={values => {
            this.validateUserFieldRef = values;
          }}
          id="username-input"
          validateWithPattern={[
            {
              pattern: /^[a-zA-Z ]+$/,
              msg: "Name must have only alpabets",
            },
            {
              pattern: /^[a-zA-Z ]{3,}$/,
              msg: "Plug in atleast 3 characters.",
            },
          ]}
        />
        <div className={`nw-form-err-msg ${userNameErrorClass}`}>
          {userInputErrorMsg}
        </div>
      </div>
    );
  }
}

UserNameInput.defaultProps = {
  className: "",
};

UserNameInput.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
};

export default UserNameInput;



// WEBPACK FOOTER //
// ./src/component/Login/UserNameInput/index.js